import deMessages from './de.json';
import deAtMessages from './de-AT.json';
import enMessages from './en.json';
import enGbMessages from './en-GB.json';
import enUsMessages from './en-US.json';
import enZaMessages from './en-ZA.json';
import esMessages from './es.json';
import fiMessages from './fi.json';
import frMessages from './fr.json';
import itChMessages from './it-CH.json';
import itMessages from './it.json';
import roMessages from './ro.json';
import slMessages from './sl.json';
import enBsMessages from './en-BS.json';
import enPrMessages from './en-PR.json';

import deLocale from './de';
import enLocale from './en';
import enZaLocale from './en-ZA';
import esLocale from './es';
import fiLocale from './fi';
import frLocale from './fr';
import itLocale from './it';
import roLocale from './ro';
import slLocale from './sl';

const messages = {
  en: enMessages,
  'en-GB': enGbMessages,
  'en-US': enUsMessages,
  'en-ZA': enZaMessages,
  'en-BS': enBsMessages,
  'en-PR': enPrMessages,
  de: deMessages,
  'de-AT': deAtMessages,
  es: esMessages,
  'es-ES': esMessages,
  fi: fiMessages,
  fr: frMessages,
  it: itMessages,
  'it-CH': itChMessages,
  ro: roMessages,
  sl: slMessages,
};

const locales = {
  en: enLocale,
  'en-ZA': enZaLocale,
  de: deLocale,
  es: esLocale,
  'es-ES': esLocale,
  fi: fiLocale,
  fr: frLocale,
  it: itLocale,
  ro: roLocale,
  sl: slLocale,
};

export default { messages, locales };



// WEBPACK FOOTER //
// ./src/app/locales/index.js